import * as moment from "moment";
import {none, option, Option} from "ts-option";
import ActivityEvent from "../../event/ActivityEvent";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import Attachment from "../../attachment/Attachment";
import {AccountingNoteApiDto} from "../../../api/model/rest";
import {InvoiceEventTypeEnum} from "../event/InvoiceEvent";
import {TransactionEventTypeEnum} from "../../transaction/event/TransactionEvent";
import {BillEventTypeEnum} from "../../bill/event/BillEvent";

/**
 * Accounting note model - used in Invoice, Transaction and Bill activity streams.
 */
export default class AccountingNote extends ActivityEvent {

	constructor(public readonly id: string,
		public readonly creator: AuthenticatedEntity,
		public readonly noteText: string,
		public readonly creationDateTime: moment.Moment,
		public readonly updateDateTime: Option<moment.Moment>,
		public readonly type: InvoiceEventTypeEnum.Note | TransactionEventTypeEnum.Note | BillEventTypeEnum.Note) {
		super();
	}

	static fromJson(json: AccountingNoteApiDto,
		type: InvoiceEventTypeEnum.Note | TransactionEventTypeEnum.Note | BillEventTypeEnum.Note): AccountingNote {
		const creationDateTime = moment(json.creationDateTime);
		const updateDateTime = json.updateDateTime ? option(moment(json.updateDateTime)) : none;
		const creator = AuthenticatedEntity.fromJson(json.creator);
		return new AccountingNote(json.id, creator, json.noteText, creationDateTime, updateDateTime, type);
	}

	getCssClass() {
		return '';
	}

	getIcon() {
		return Icon.Note;
	}

	getIconColor(): IconColor {
		return IconColor.NoteYellow;
	}

	getAttachments(): Attachment[] {
		return [];
	}

	getActivityAdditionalMessages(): string[] {
		return [];
	}

	getActivityType(): string {
		return "NOTE";
	}

	getActivityMessage(): string {
		return `"${this.noteText}"`;
	}

	getCreationDate(): moment.Moment {
		return this.creationDateTime;
	}

	getId() {
		return this.id;
	}

	/**
	 * Get user display name.
	 */
	getUserDisplayName(): string {
		return this.creator.getDisplayName();
	}

	copy({
		id = this.id,
		creator = this.creator,
		noteText = this.noteText,
		creationDateTime = this.creationDateTime,
		updateDateTime = this.updateDateTime,
	}) {
		return new AccountingNote(id, creator, noteText, creationDateTime, updateDateTime, this.type);
	}
}
